<template>
	<div class="pedigree">
		<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
			<div class="empty" v-if="items.length==0"></div>

			
			<van-list
			v-model="loading"
			:finished="finished"
			:finished-text="items.length==0?('暂无族谱！'):'没有更多族谱了'"
			@load="getPedigree"
			>
				<van-card
				  :title="item.name+(item.parent_name?(' - '+item.parent_name):'')"
				  :tag="item.family_name+'氏'"
				  v-for="(item,index) in items"
				  :key="index"
				  @click="goPedigree(item.id)"
				>
					<template #thumb>
						<img :src="item.img?(item.img.indexOf('http')==-1?(attach_url+item.img):item.img):coverImg" style="width:100%; height:100%;"/>
						<span v-if="!item.img" class="clans-title" :style="item.name.length>4?('font-size:'+(14-(item.name.length-4)*2)+'px'):''">{{item.name}}</span>
					</template>
					<template #desc>
						<div class="van-card__desc van-ellipsis"><van-icon name="location-o" />{{item.address}}</div>
					</template>
					<template #tags>
						<van-tag plain type="danger" v-if="item.visit==1">私有</van-tag>
						<van-tag plain type="danger" v-if="item.visit==0">公开</van-tag>
						已录<span class="skin_color" style="margin:0 5px;">{{item.personals}}</span>人
					</template>
					<template #price>
						堂号：{{item.hall_name}}
					</template>
					<template #num v-if="item.mark_date">
						祭祖：{{filterMarkDate(item.mark_date)}}
					</template>
				</van-card>
			</van-list>

		</van-pull-refresh>

		<van-popup v-model="showEditInfo" round position="bottom" :style="{ 'max-height': '80%' ,'padding-top':'10px' ,'padding-bottom':'50px'}">
			<PedigreeInfo :pdgInfo="pedigreeInfo" :families="$parent.familyNameIndex" :imgList="imgList" :edit="false" @callAfterSave="afterSavePedigree"></PedigreeInfo>
		</van-popup>
	</div>
</template>

<script>
import {List,Card } from "vant";
import PedigreeInfo from "@/components/Clans/PedigreeInfo";
import {lunarUtil} from "@/utils/lunar.js";

export default {
	name: "pedigree",
	components: {
		"van-list":List,
		"van-card":Card,
		"PedigreeInfo":PedigreeInfo
	},
	props:['keyword'],
	data() {
		return {
			title: "族谱",
			attach_url:this.Conf.serverPre,
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),

			lunarObj:null,

			items: [],
			page:0,
			pageSize:0,
			total:0,
			loading: false,
			finished: false,
			refreshing: false,

			showEditInfo:false,
			pedigreeInfo:{},
			imgList:[],

			coverImg:require("../../assets/img/clans/cover.jpg")
		};
	},
	created() {
		this.$parent.code = "list";
		this.lunarObj = new lunarUtil();
		this.getStateConfigs();
		this.getPedigree()
	},
	computed: {
	},
	methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		getPedigree(){
			if (this.finished) {
				return false;
			}
			this.loading = true;
			setTimeout(() => {
				if (this.refreshing) {
					this.items = [];
					this.refreshing = false;
				}
				this.page = this.page+1;

				var params = {
					p: this.page,
					key:this.keyword
				};
				var url = this.Conf.serverUrl + "clans/pedigreeList?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
						if (response.data.page == 1) {
							this.pageSize = response.data.pageSize;
							this.total = response.data.total;
							this.items = response.data.data;
						}else if(response.data.data){
							this.items = this.items.concat(response.data.data);
						}
						if(this.page*this.pageSize >= this.total){
							this.finished = true;
						}
						this.loading = false;
				})
				.catch(error => {});
			}, 1000);
		},
		onRefresh(cur) {
			this.finished = false;
			this.page = cur?(this.page-1):0;
			this.getPedigree();
		},
		searchData(){
			this.onRefresh();
		},
		afterSavePedigree(){
			this.showEditInfo = false;
			this.onRefresh();
		},
		onAdd(){
			
			if(this.imgList.length == 0){
				this.imgList = [{url:this.coverImg, isImage: true}];
			}
			this.showEditInfo = true;
		},
		goPedigree(pid){
			this.$parent.goPedigree(pid)
		},
		filterMarkDate(md){
			if(md){
				let mds = md.split("-");
				return this.lunarObj.month2Zh(parseInt(mds[0]))+this.lunarObj.day2Zh(parseInt(mds[1])-1);
			}
			return md;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Clans/Pedigrees.vue